module.exports = __webpack_public_path__ + "img/1-2.3bdc9f98.png";